import { SubscriptionPlan } from 'entities/subscription_plan';
import { ViewModel } from '.';

export class SubscriptionPlanViewModel extends ViewModel<SubscriptionPlan> {
  public getLimitCount = () => {
    if (!this.object.limitCount) {
      return '無制限';
    }
    return this.object.limitCount;
  };

  public getName = () => {
    switch (this.object.name) {
      case 'free':
        return 'フリー';
      case 'mini':
        return 'ミニ';
      case 'standard':
        return 'スタンダード';
      case 'standard_extension':
        return 'スタンダード拡張';
      case 'volume':
        return 'ボリューム';
      default:
        return '-';
    }
  };
}
